import { StreamTransport as OvpStreamTransport, DrmType as OvpDrmType } from '@sky-uk-ott/core-video-sdk-js-ovp-service';
/**
 * @deprecated
 * Please use OvpDrmType, OvpCdn, OvpStreamTransport or OvpDeviceCapability
 */ (function(Ovp) {
    Ovp.DrmType = OvpDrmType;
    Ovp.StreamTransport = OvpStreamTransport;
})(Ovp || (Ovp = {}));
export var Ovp;

//# sourceMappingURL=ovp-namespace.js.map